import { LiftLog, RoutinePlan, Store } from '../types';
import { FLEXIBLE_PLAN, STARTER_PLAN, STARTER_ROUTINE } from '../data/catalog';

const STORAGE_KEY = 'repday-store-v1';

export const initialStore: Store = {
  lifts: [], bodyweights: [], routines: [STARTER_PLAN], activeRoutineId: STARTER_PLAN.id,
  oneOffExercises: {}, customExercises: [], unit: 'lb', reminders: false, morning: '08:00', evening: '20:00'
};

function migrateExerciseName(name: string) {
  if (name === 'Knee Raise / Crunch Machine') return 'Machine Seated Crunch';
  if (name === 'Hanging Knee / Leg Raise') return 'Hanging Knee Raise';
  return name;
}

function migrateRoutine(routine: RoutinePlan): RoutinePlan {
  return {
    ...routine,
    days: Object.fromEntries(Object.entries(routine.days || {}).map(([day, session]) => [day, {
      ...session,
      exercises: (session.exercises || []).map(migrateExerciseName)
    }]))
  };
}

export function loadStore(storageKey = STORAGE_KEY): Store {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return { ...initialStore, routines: [STARTER_PLAN, FLEXIBLE_PLAN], activeRoutineId: FLEXIBLE_PLAN.id };

    const saved = JSON.parse(raw);
    if (Array.isArray(saved.routines) && saved.routines.length) {
      const routinesFromDisk = saved.routines.map(migrateRoutine);
      const alreadyAdded = routinesFromDisk.some((routine: RoutinePlan) => routine.id === FLEXIBLE_PLAN.id);
      const routines = alreadyAdded ? routinesFromDisk : [...routinesFromDisk, FLEXIBLE_PLAN];
      const activeRoutineId = !alreadyAdded && routinesFromDisk.length === 1
        ? FLEXIBLE_PLAN.id
        : routines.some((routine: RoutinePlan) => routine.id === saved.activeRoutineId)
          ? saved.activeRoutineId
          : routines[0].id;

      return {
        ...initialStore,
        ...saved,
        routines,
        lifts: (saved.lifts || []).map((lift: LiftLog) => ({ ...lift, exercise: migrateExerciseName(lift.exercise) })),
        customExercises: saved.customExercises || [],
        oneOffExercises: saved.oneOffExercises || {},
        activeRoutineId
      };
    }

    const legacyDays = saved.routine && Object.keys(saved.routine).length ? saved.routine : STARTER_ROUTINE;
    const legacy: RoutinePlan = { id: 'legacy-chest-back-legs', name: 'Chest / Back / Legs', days: legacyDays };
    return {
      ...initialStore,
      ...saved,
      lifts: (saved.lifts || []).map((lift: LiftLog) => ({ ...lift, exercise: migrateExerciseName(lift.exercise), routineId: lift.routineId || legacy.id })),
      routines: [migrateRoutine(legacy), FLEXIBLE_PLAN],
      activeRoutineId: FLEXIBLE_PLAN.id,
      oneOffExercises: {}
    };
  } catch {
    return initialStore;
  }
}

export function saveStore(value: Store, storageKey = STORAGE_KEY) {
  localStorage.setItem(storageKey, JSON.stringify(value));
}
